import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=06c9ee0a&lang=pug&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c9ee0a')) {
      api.createRecord('06c9ee0a', component.options)
    } else {
      api.reload('06c9ee0a', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=06c9ee0a&lang=pug&", function () {
      api.rerender('06c9ee0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Carousel.vue"
export default component.exports